module.exports = __webpack_public_path__ + "img/logo_small.6ed24543.png";